export default __webpack_public_path__ + "static/media/hero_bg.936b6408.jpeg";